import { useCallback } from 'react';
import { useAppStore } from  "@/hooks/use-app-store"
import { RefreshCcw } from 'lucide-react';

type StartStateProps = {
  onStart: () => void;
  isConnected: boolean;
};

type ResetStateProps = {
  onReset: () => void;
};

type Props = {
  soundURL: string;
  onStart?: () => void;
  onReset?: () => void;
  StartState?: React.ComponentType<StartStateProps>;
  ResetState?: React.ComponentType<ResetStateProps>;
};

const DefaultStartState =({ onStart, isConnected }:StartStateProps) => (
  <div className="fixed inset-0 z-50 h-screen w-screen flex items-center justify-center bg-black/75 backdrop-blur-xs">
    <button
      onClick={onStart}
      disabled={!isConnected}
      className="flex h-48 w-48 items-center justify-center rounded-full border-2 border-cyan-400 bg-cyan-500 text-white shadow-[0_0_24px_2px_#06b6d4] cursor-pointer text-3xl font-bold transition-all duration-200 hover:scale-105 hover:shadow-[0_0_32px_4px_#06b6d4] disabled:cursor-not-allowed disabled:bg-gray-500 disabled:border-gray-400 disabled:shadow-none"
    >
      <span>{isConnected ? 'BEGIN' : 'WAITING'}</span>
    </button>
  </div>
);

const DefaultResetState = ({ onReset }:ResetStateProps)  => (
  <button
    onClick={onReset}
    aria-label="Reset Session"
    className="hidden fixed bottom-24 right-24 z-150 p-3 bg-black/20 text-white backdrop-blur-sm rounded-full transition-colors hover:bg-white/40"
  >
    <RefreshCcw className="h-12 w-12" />
  </button>);


export const StartOverlay = ({
  soundURL,
  onStart: onStartProp,
  onReset: onResetProp,
  StartState = DefaultStartState,
  ResetState = DefaultResetState,
}: Props) => {
  const isStarted = useAppStore(state=>state.isStarted);
  const isConnected = useAppStore(state=>state.isConnected);
  const start = useAppStore(state=>state.start);

  const handleStart = useCallback(() => {
    try {
      new Audio(soundURL).play();
    } catch (error) {
      console.error('Audio playback failed:', error);
    }

    setTimeout(() => {
      if (onStartProp) {
        onStartProp();
      } else {
        start();
      }
    }, 300);
  }, [onStartProp, soundURL, start]);

  const handleReset = useCallback(() => {
    if (onResetProp) {
      onResetProp();
    } else {
      // window.location.reload();
      window.location.replace("/");
    }
  }, [onResetProp]);

  return isStarted ? (
    <ResetState onReset={handleReset} />
  ) : (
    <StartState isConnected={isConnected} onStart={handleStart} />
  );
};